import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RunListComponent } from './run-list/run-list.component';
import { RunDetailComponent } from './run-detail/run-detail.component';

import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalHttpInterceptor } from './interceptors/global-http.interceptor';
import { DataService } from './services/data.service';
import { SampleDetailComponent } from './sample-detail/sample-detail.component';
import { SampleListComponent } from './sample-list/sample-list.component';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';

import { environment } from '../environments/environment';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { RetestListComponent } from './retest-list/retest-list.component';

@NgModule({
  declarations: [
    AppComponent,
    RunListComponent,
    RunDetailComponent,
    SampleDetailComponent,
    SampleListComponent,
    UnauthorizedComponent,
    RetestListComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TableModule,
    CardModule,
    ButtonModule,
    ToastModule,
    DialogModule,
    AuthModule.forRoot({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        // Request this audience at user authentication time
        audience: environment.auth0.audience,
    
        // Request this scope at user authentication time
        scope: environment.auth0.scope,
        redirect_uri: window.location.origin
      },
      httpInterceptor: {
        allowedList: [
          {
            // Match any request that starts 'https://transnetyx-poc.us.auth0.com/api/v2/' (note the asterisk)
            uri: environment.apiUrl + '*',
            tokenOptions: {
            }
          }
        ]
      }
    })
  ],
  providers: [
  DataService,
  MessageService,
  { 
    provide: HTTP_INTERCEPTORS, 
    useClass: AuthHttpInterceptor, 
    multi: true 
  },
  {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpInterceptor,
      multi: true
  }
],
  bootstrap: [AppComponent]
})
export class AppModule { }
